const firebaseConfig = {
  apiKey: "AIzaSyAZZVeWYcdYWGMNQL5OKUhPM7L9OQ6PGt0",
  authDomain: "gdsvueking.firebaseapp.com",
  databaseURL: "https://gdsvueking.firebaseio.com",
  projectId: "gdsvueking",
  storageBucket: "gdsvueking.appspot.com",
  messagingSenderId: "267873383702",
  appId: "1:267873383702:web:4aa5009bc87eaf7a5e0c37",
  measurementId: "G-EQYDX2Z76J"
};

export default firebaseConfig;
